"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderCreateRequestToJSON = exports.PostOrderCreateRequestFromJSONTyped = exports.PostOrderCreateRequestFromJSON = exports.instanceOfPostOrderCreateRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the PostOrderCreateRequest interface.
 */
function instanceOfPostOrderCreateRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    return isInstance;
}
exports.instanceOfPostOrderCreateRequest = instanceOfPostOrderCreateRequest;
function PostOrderCreateRequestFromJSON(json) {
    return PostOrderCreateRequestFromJSONTyped(json, false);
}
exports.PostOrderCreateRequestFromJSON = PostOrderCreateRequestFromJSON;
function PostOrderCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
        'pointOfSale': !(0, runtime_1.exists)(json, 'pointOfSale') ? undefined : json['pointOfSale'],
    };
}
exports.PostOrderCreateRequestFromJSONTyped = PostOrderCreateRequestFromJSONTyped;
function PostOrderCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
        'pointOfSale': value.pointOfSale,
    };
}
exports.PostOrderCreateRequestToJSON = PostOrderCreateRequestToJSON;
